import { Component } from '@angular/core';
import { IStatusPanelParams } from 'ag-grid-community';

@Component({
  selector: 'app-total-amount-status',
  template: `
    <div class="p-2 font-semibold">
      Total Amount: $ {{ totalAmount.toLocaleString() }}
    </div>
  `
})
export class TotalAmountComponent {
  public totalAmount = 0;
  private params!: IStatusPanelParams;
  private field = 'amount'; // Default field

  // Called by AG Grid on init
  agInit(params: IStatusPanelParams & { field?: string }): void {
    this.params = params;
    this.field = params.field || 'amount';


    // Calculate on load
    this.calculateTotal();

    // Recalculate when grid updates
    this.params.api.addEventListener('modelUpdated', () => this.calculateTotal());
    this.params.api.addEventListener('firstDataRendered', () => this.calculateTotal());
  }

  private calculateTotal() {
    let total = 0;
    const displayedRows = this.params.api.getRenderedNodes(); // Only currently rendered rows
    displayedRows.forEach(node => {
      if (node.data && node.data[this.field] != null) {
        total += Number(node.data[this.field]);
      }
    });
    this.totalAmount = total;
  }
}
